<template>
    <div class="story-body">
        <story-controls class="story-mobile-controls" :story="story"></story-controls>
        <div class="story-body-content">
            <transition name="fade" mode="out-in">
                <p v-if="story.content">{{story.content}}</p>
                <no-content v-else
                    :header="noContentHeader"
                    :paragraph="noContentParagraph">
                </no-content>
            </transition>
        </div>
    </div>
</template>

<script>
    import StoryControls from './StoryControls.vue'
    import NoContent from '../errors/NoContent.vue'

    export default {
        data() {
            return {
                noContentHeader: 'Sorry, there is no content for this article.',
                noContentParagraph: 'Click \'Read full story\'',
                isLiked: false
            }
        },
        props: {
            story: {
                type: Object
            }
        },
        components: {
            StoryControls,
            NoContent
        }
    }
</script>

<style scoped>
    .story-body {
        width: 70%;
        display: flex;
        margin: 0 auto;
    }

    .story-mobile-controls {
        display: none !important;
    }

    .story-body-content p {
        line-height: 1.8;
    }

    @media only screen and (max-width: 768px) { 
        .story-body {
            width: 90%
        }
        
        .story-mobile-controls {
            display: flex !important;
        }
    }

    @media only screen and (max-width: 500px) {
        .story-body-content p {
            font-size: 13px;
            text-transform: capitalize; 
        } 

        .story-body-content {
            width: 85%;
        }
    }

    
</style>


// WEBPACK FOOTER //
// src/components/story/StoryBody.vue